import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useClassName } from '../../../../hooks';
import { TagContext } from '../../Tag.context';
import { Space } from '../../../Space/Space';
import './Container.scss';
export const Container = ({ children }) => {
    const { variant, onDelete } = useContext(TagContext);
    const className = useClassName({
        name: 'tag',
        prefixed: true,
    }, variant ?? 'primary', !!onDelete && 'deletable');
    return (_jsx("div", { className: className, children: _jsx(Space, { direction: 'horizontal', size: 'xxs', children: children }) }));
};
